export default __webpack_public_path__ + "static/top1-b0d8323127dde8139a5a5e6d359dd4bb.jpeg";